module.exports = __webpack_public_path__ + "qr_code_ios_civic.c423f84.png";